import axios from "axios";
import { APIConstants } from "../../constants/ApiConstants";
import { useState } from "react";
import formatDate from "../../util/dateFormat";

export const getFinanceReports = async (searchValue: string) => {
  let url = `${process.env.REACT_APP_API_URL}${APIConstants.finance_reports}?limit=100&module=finance_reports&feature=finance_reports`;
  if (searchValue) {
    url += `&search=${searchValue}`;
  }
  try {
    const response = await axios.get(url);
    return response?.data;
  } catch (error) {
    console.error(error);
    return [];
  }
};

export const downloadFinanceReports = async (searchValue: string) => {
  try {
    const financeReportsData = await getFinanceReports(searchValue);

    if (financeReportsData.data && financeReportsData.data.length > 0) {
      const flattenedData = financeReportsData.data.flatMap(
        (category: { data: any[]; category_name: any }) => {
          return category.data.map((report) => ({
            id: report.id,
            category_name: category.category_name,
            report_name: report.report_name,
            report_icon: report.report_icon,
            destination: report.destination,
            report_url: report.report_url,
            updatedAt: report.updatedAt,
            createdAt: report.createdAt,
          }));
        }
      );

      const csvContent = convertDataToCSV(flattenedData);
      const blob = new Blob([csvContent], { type: "text/csv" });
      const a = document.createElement("a");
      a.href = window.URL.createObjectURL(blob);
      a.download = "Finance_Reports.csv";
      a.click();
    } else {
      console.error("No finance reports data found.");
    }
  } catch (error) {
    console.error("Error downloading finance reports:", error);
  }
};

export const convertDataToCSV = (data: any[]) => {
  const headers =
    "Id,Category Name,Report Name,Report Icon,Destination,Report URL,Update At,Created At";
  const rows = data.map((obj) => {
    return `${obj.id},${obj.category_name},${obj.report_name},${obj.report_icon},${obj.destination},${obj.report_url},${obj.updatedAt},${obj.createdAt}`;
  });
  return `${headers}\n${rows.join("\n")}`;
};

export const handleDownloadPredefinedCSV = () => {
  const predefinedFileURL = require("../../assets/FinReport.csv");
  const a = document.createElement("a");
  a.href = predefinedFileURL;
  a.download = "Finance_Report.csv";
  a.click();
};

export const removeEmptyRows = (csvContent: string) => {
  const rows = csvContent.split("\n");
  const nonEmptyRows = rows.filter((row) => {
    return row.trim() !== "" && !/^,+$/g.test(row.trim());
  });
  const updatedCsvContent = nonEmptyRows.join("\n");
  return updatedCsvContent;
};

export const handleUpload = async (
  file: File | null,
  setLoading: React.Dispatch<boolean>,
  setShowModal: React.Dispatch<boolean>,
  setUploadError: React.Dispatch<boolean>,
  setErrorMessage: React.Dispatch<string>,
  setSuccessMessage: React.Dispatch<string>
) => {
  if (!file) {
    return;
  }
  setLoading(true);

  try {
    const reader = new FileReader();
    reader.onload = async (e) => {
      if (e.target?.result) {
        const csvContent = e.target.result as string;
        const updatedCsvContent = removeEmptyRows(csvContent);
        const formData = new FormData();
        formData.append(
          "csvFile",
          new Blob([updatedCsvContent], { type: "text/csv" }),
          file.name
        );
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}${APIConstants.finance_reports}?module=finance_reports&feature=finance_reports`,
          formData
        );
        setSuccessMessage(response.data.data);
        setLoading(false);
        setShowModal(true);
        setUploadError(false);
      }
    };
    reader.readAsText(file);
  } catch (error: any) {
    setUploadError(true);
    setErrorMessage(error);
  } finally {
    setLoading(false);
    setShowModal(false);
  }
};
